import {useDispatch, useSelector} from 'react-redux';
import {vendorsActions} from '../state/actions/vendors.actions';

export const useBatchVendors = () => {
  const dispatch = useDispatch();
  const vendors = useSelector(state => state?.vendor?.vendors || []);

  const loadVendors = ({results = [], vendorIdKey = 'vendor_id'}) => {
    const normalize = id => (id == null ? null : String(id));
    const newVendorsIds = new Set(
      results
        .map(v => normalize(v[vendorIdKey]))
        .filter(Boolean)
    );
    const existingVendorsIds = new Set(
      vendors
        .map(v => normalize(v[vendorIdKey]))
        .filter(Boolean)
    );
    const vendorsToAdd = Array.from(newVendorsIds).filter(id => !existingVendorsIds.has(id));

    if (vendorsToAdd.length === 0) return;

    dispatch(vendorsActions.getBatchVendors({
      data: {vendor_ids: vendorsToAdd},
    }));
  }

  return {
    loadVendors,
  }
}


